/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { HighlightTransformService, HighlightTransformResult } from '../common/services/highlight-transform.service';

@Pipe({
    name: 'highlight'
})
export class HighlightPipe implements PipeTransform {

    constructor(private highlightTransformService: HighlightTransformService) { }

    transform(text: string, search: string): string {
        const highlightTransformResult: HighlightTransformResult = this.highlightTransformService.highlight(text, search);
        return highlightTransformResult.text;
    }
}
